import Vue from "vue";
import Router from 'vue-router';
import Home from './views/Home.vue';
import Contact from "./views/Contact.vue";
import store from './store';
import Confirm from './views/EmailConfirm';
import Payment from './views/PaymentConfirm';
import Faq from './views/Faq'
import ResetPassword from './views/ResetPassword'
import AskEmail from './views/AskEmail'
import Takerdv from './views/Takerdv'
import Ticket from './views/Ticket'
import RegisterRecept from './views/RegisterRecept'
import ApprovedRollup from './views/ApprovedRollup'
import Edocument from './views/Edocument'
import DemandFormular from './views/DemandFormular'






Vue.use(Router)

const routes = [{
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: 'Accueil',
        }
    },
    {
        path: '/demand',
        name: 'demand',
        component: () =>
            import ('./views/Demand.vue'),
        meta: {
            middleware: 'auth',
            title: 'Demandes',
        }
    },
    {
        path: '/register',
        component: () =>
            import ('./views/Register.vue'),
        name: 'register',
        meta: {
            title: 'Inscription',
            middleware: 'guest'
        }
    },
    {
        path: '/login',
        component: () =>
            import ('./views/Login.vue'),
        name: 'login',
        meta: {
            title: 'Connexion',
            middleware: 'guest'
        }
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact,
        meta: {
            title: 'Contact',
        }
    },
    {
        path: '/confirm',
        name: 'Confirm',
        component: Confirm,
        meta: {
            title: 'Confirmation',
            middleware: 'guest',
        }
    },
    {
        path: '/payment/:code?',
        name: 'Payment',
        component: Payment,
        props: (route) => ({ code: route.query.code }),
        meta: {
            middleware: 'auth',
            title: 'Paiement',
        }
    },
    {
        path: '/faq',
        name: 'Faq',
        component: Faq,
        meta: {
            title: 'Foire à questions',
        }
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: {
            middleware: 'guest',
            title: 'ResetPassword',
        },
        props: (route) => ({ code: route.query.q, token: route.query.token }),
    },
    {
        path: '/askemail',
        name: 'AskEmail',
        component: AskEmail,
        meta: {
            middleware: 'guest',
            title: 'AskEmail',
        }
    },
    {
        path: '/rdv',
        name: 'Takerdv',
        component: Takerdv,
        meta: {
            middleware: 'auth',
            title: 'Takerdv',
        }
    },
    {
        path: '/ticket',
        name: 'Ticket',
        component: Ticket,
        meta: {
            middleware: 'auth',
            title: 'Ticket',
        }
    },

    {
        path: '/edocument',
        name: 'Edocument',
        component: Edocument,
        meta: {
            middleware: 'auth',
            title: 'Edocument',
        }
    },
    {
        path: '/demandformular/:id',
        name: 'DemandFormular',
        component: DemandFormular,
        meta: {
            title: 'demand-formular',
        }
    },
    {
        path: '/registerrecept/:id',
        name: 'RegisterRecept',
        component: RegisterRecept,
        meta: {
            title: 'Register-Recept',

        }
    },
    {
        path: '/approvedrollup/:id',
        name: 'ApprovedRollup',
        component: ApprovedRollup,
        meta: {
            title: 'Approved-Rollup',

        }
    }



]

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach((to, from, next) => {
    document.title = `E-Visa - ${to.meta.title}`
    store.dispatch('getUser')
    if (to.meta.middleware == 'auth') {
        if (store.state.authenticated) {
            next()
        } else {
            //next()
            next({ name: 'login' })
        }
    } else if (to.meta.middleware == "guest") {
        if (store.state.authenticated) {
            next({ name: "demand" })
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router